import { render } from "./PlacaMercosul.vue?vue&type=template&id=6c6a19ce&scoped=true"
import script from "./PlacaMercosul.vue?vue&type=script&lang=js"
export * from "./PlacaMercosul.vue?vue&type=script&lang=js"

import "./PlacaMercosul.vue?vue&type=style&index=0&id=6c6a19ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6a19ce"]])

export default __exports__